module.exports = __webpack_public_path__ + "static/media/cz.2292229b.svg";